import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useIsOrgUser } from 'app/hooks/useIsOrgUser'
import { useUser } from 'app/utils'

/** Shared access inputs for the manage-users settings pages (active and invited
 * users): the current user, whether they are an org user, and whether they may
 * edit a user. Each page keeps its own `canManageUsers` rule and redirect
 * targets, which differ between the two pages. */
export function useManageUsersPageAccess() {
  const me = useUser()
  const isOrgUser = useIsOrgUser()
  const canEditUser = useCheckPermission()([`org:settings:manage-users`, `users:manage`])

  return { me, isOrgUser, canEditUser }
}
